module.exports = __webpack_public_path__ + "images/b78f8221f96a71d7d6428366ee150660.png";